import React from "react";
import { Clock, Printer, Wand2, Crown } from "lucide-react";

const items = [
  {
    icon: Crown,
    title: "Base Package",
    price: "$350",
    unit: "4 hours",
    desc: "Photo Booth or 360° Booth, on-site attendant, premium props, custom backdrop, digital gallery.",
    testid: "pricing-base",
  },
  {
    icon: Clock,
    title: "Additional Hour",
    price: "+$50",
    unit: "per hour",
    desc: "Extend the magic. Each additional hour beyond your 4-hour minimum.",
    testid: "pricing-extra-hour",
  },
  {
    icon: Printer,
    title: "Printed Photos",
    price: "+$3",
    unit: "per print",
    desc: "On-site, instant-dry premium prints — keepsakes guests take home.",
    testid: "pricing-prints",
  },
  {
    icon: Wand2,
    title: "Themed Props",
    price: "+$50",
    unit: "flat add-on",
    desc: "Curated prop set tailored to your event theme — masquerade, vintage, Hollywood, more.",
    testid: "pricing-props",
  },
];

export default function Pricing() {
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="lk-section px-6 md:px-12 lg:px-24 bg-[#0a0a0a] border-y border-[#D4AF37]/10"
    >
      <div className="max-w-4xl mb-16">
        <span className="text-xs uppercase tracking-[0.3em] text-[#D4AF37]">Transparent Pricing</span>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light mt-4 leading-tight">
          Honest rates.
          <br />
          <span className="italic gold-gradient-text">No surprises.</span>
        </h2>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {items.map((it) => (
          <div
            key={it.title}
            data-testid={it.testid}
            className="lk-card p-8 flex flex-col h-full"
          >
            <it.icon className="w-7 h-7 text-[#D4AF37] mb-6" />
            <h3 className="font-serif text-2xl mb-3">{it.title}</h3>
            <div className="flex items-baseline gap-2 mb-4">
              <span className="font-serif text-4xl gold-gradient-text">{it.price}</span>
              <span className="text-xs uppercase tracking-wider text-zinc-500">{it.unit}</span>
            </div>
            <p className="text-zinc-400 text-sm leading-relaxed">{it.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
